module.exports = __webpack_public_path__ + "static/img/account-ready-2x.f95af50.png";